import React, { useEffect, useRef, useState } from 'react';
export default function CalendarLoadingState({ busy, error, locationName, onRetry }) {
  const [visible, setVisible] = useState(false);
  const shownAt = useRef(0);
  useEffect(() => {
    let timer;
    if (error) { shownAt.current = Date.now(); setVisible(true); }
    else if (busy) {
      timer = setTimeout(() => { shownAt.current = Date.now(); setVisible(true); }, 120);
    } else {
      timer = setTimeout(() => setVisible(false), Math.max(0, 280 - (Date.now() - shownAt.current)));
    }
    return () => clearTimeout(timer);
  }, [busy, error]);
  if (!visible) return null;
  return <div className={`calendar-loading-state ${error ? 'has-error' : ''}`} role={error ? 'alert' : 'status'}>
    {!error && <span className="calendar-loading-dots" aria-hidden="true"><i /><i /><i /></span>}
    <div><strong>{locationName || 'Kalender'}</strong><span>{error || 'Kalender wird geladen'}</span></div>
    {error && <button type="button" onClick={onRetry}>Erneut laden</button>}
  </div>;
}
